import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { spliceOut } from '../../../sharpr/util/spliceOut.js';

export function PostBulkUpdateRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.PostBulkUpdate', {
		url: '/admin/posts/bulk_update',
		controllerAs: 'vm',
		controller: PostBulkUpdateCtrl,
		templateUrl: '/ng/hub/Post/BulkUpdate/PostBulkUpdateCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Post/BulkUpdate/PostBulkUpdateCtrl.css'),
			$title: () => 'Bulk Update Posts',
		},
	});
}

export class PostBulkUpdateCtrl {
	constructor(Api, Identity, Logger, FineTunePosts, Post, modal) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.Identity = Identity;
		this.Logger = Logger;
		this.FineTunePosts = FineTunePosts;
		this.PostService = Post;
		this.modal = modal;
		// setup
		this.destinationHubs = [];
		const hubId = this.Identity.currentClient().id;
		this.userHubChoices = this.Identity.hubChoices();
		this.FineTunePosts.avoidStoryResults = true;
		this.fineTunerClosed = true;
		this.search = {
			limit: 100,
		};
		this.posts = [];
		this.excluded = [];
		this.actionType = 'delete';
		this.actionOptions = [
			{ id: 'delete', name: 'Delete Posts' },
			{ id: 'destroy', name: 'Destroy Posts' },
			{ id: 'archive', name: 'Archive Posts' },
			{ id: 'copy', name: 'Copy Posts' },
			{ id: 'move', name: 'Move Posts' },
			{ id: 'update', name: 'Update Posts' },
		];
	}

	loadMore() {
		this.FineTunePosts.fetchNextPage().then(posts => this.posts.push(...posts));
	}

	toggleExcluded(id) {
		if (this.excluded.includes(id)) {
			spliceOut(this.excluded, id);
		} else {
			this.excluded.push(id);
		}
	}

	toggleCheckboxes() {
		if (this.excluded.length === 0) {
			for (const { id } of this.posts) {
				this.excluded.push(id);
			}
		} else {
			this.excluded.length = 0;
		}
	}

	viewPost(post) {
		const reload = () => this.reloadPost(post);
		this.PostService.viewFullscreen(post).then(reload, reload);
	}

	editPost(post) {
		const reload = () => this.reloadPost(post);
		this.PostService.edit({ id: post.id }).then(reload, reload);
	}

	async reloadPost(post) {
		const newPost = await this.Api.get(`/v3/posts/${post.id}`);
		Object.assign(post, newPost);
	}

	submit() {
		switch (this.actionType) {
			case 'delete':
			case 'destroy':
			case 'archive':
				this.modal
					.confirm({ text: `Are you sure you want to ${this.actionType} all selected posts?` })
					.then(() => this.bulkUpdate());
				break;
			case 'copy':
			case 'move':
				this.showHubList = true;
				break;
			case 'update':
				// this.showUpdateScreen = true;
				// TODO: add <sh-modal /> to update submitter, tags, categories, classifications, etc
				this.modal.alert({ text: 'Not yet implemented' });
				break;
			default:
				alert('Please choose an action');
		}
	}

	submitHubChoices() {
		this.showHubList = false;
		this.bulkUpdate({
			hub_ids: this.destinationHubs,
		});
	}

	submitUpdates() {
		// TODO: send updates to this.bulkUpdate(updates)
	}

	bulkUpdate(moreOptions = {}) {
		const postIds = this.posts.map(post => post.id).filter(id => !this.excluded.includes(id));
		this.isProcessing = true;
		this.Api.submitJob('post', `/v2/posts/bulk_update`, {
			post_ids: postIds,
			action: this.actionType,
			...moreOptions,
		})
			.then(response => {
				if (response.data.success === true) {
					this.pendingJob = true;
					response.onJobComplete(() => {
						this.isProcessing = false;
						this.pendingJob = false;
						this.modal.alert({ text: 'Completed successfully!' });
					});
				} else {
					this.showError(response);
				}
			})
			.catch(error => {
				this.Logger.write('POST_MASS_DELETE_DEBUG', 'Error mass deleting posts:', error);
			});
	}

	showError(response) {
		const error = JSON.stringify(response, null, 4);
		this.modal.html({ escapedHtml: `<div>Error: <pre>${error}</pre></div>` });
	}
}
